import { c as _c } from "react/compiler-runtime";
import { styled } from '@classify/react-core-components/styles';
import { translate } from '@openclassrooms/translations';
import CCBYIcon from './images/CCBYIcon';
import CCNCIcon from './images/CCNCIcon';
import CCNDIcon from './images/CCNDIcon';
import CCSAIcon from './images/CCSAIcon';
import CCIcon from './images/CCIcon';
interface CourseLicensesProps {
  license: string;
}
const LicenseList = styled('ul')(({
  theme: {
    breakpoints
  }
}) => ({
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  padding: 0,
  margin: 0,
  [breakpoints.up('xs')]: {
    flexDirection: 'row'
  }
}));
const IconsWrapper = styled('li')(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  marginRight: spacing(1)
}));
const Link = styled('a')({
  color: 'currentcolor',
  '&:hover': {
    color: 'inherit'
  }
});
const Icon = styled('svg')({
  width: 20,
  height: 20
});
const CourseLicenses = t0 => {
  const $ = _c(12);
  const {
    license
  } = t0;
  let t1;
  if ($[0] !== license) {
    t1 = license.replace("CC-", "").toLowerCase();
    $[0] = license;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const licenseUrl = `https://creativecommons.org/licenses/${t1}/${license === "CC-BY-SA" ? "4.0" : "2.0"}/`;
  let t2;
  if ($[2] !== license) {
    t2 = () => {
      const licenses = license.split("-");
      const iconsPerLicense = {
        BY: <IconsWrapper key="BY"><CCBYIcon as={Icon} aria-label="BY" /></IconsWrapper>,
        NC: <IconsWrapper key="NC"><CCNCIcon as={Icon} aria-label="NC" /></IconsWrapper>,
        ND: <IconsWrapper key="ND"><CCNDIcon as={Icon} aria-label="ND" /></IconsWrapper>,
        SA: <IconsWrapper key="SA"><CCSAIcon as={Icon} aria-label="SA" /></IconsWrapper>,
        default: <IconsWrapper key="CC"><CCIcon as={Icon} aria-label="CC" /></IconsWrapper>
      };
      return licenses.map(licenseName => iconsPerLicense[licenseName] || iconsPerLicense.default);
    };
    $[2] = license;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const licenseStringToComponents = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = translate("course.license.label");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== licenseStringToComponents) {
    t4 = licenseStringToComponents();
    $[5] = licenseStringToComponents;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <LicenseList>{t4}</LicenseList>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== licenseUrl || $[10] !== t5) {
    t6 = <Link href={licenseUrl} title={t3}>{t5}</Link>;
    $[9] = licenseUrl;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default CourseLicenses;